import { buildDashboardTabNotificationsPath } from "../utils/dashboardTabNotifications";

const MODULE_TO_TAB = {
  marketplace: "rfq",
  procurement: "rfq",
  contract_manufacturing: "cm",
  infrastructure: "infra",
  approval: "p2p",
  logistics: "logistics",
  auction: "auctions",
  payment: "fulfilment",
};

const TYPE_TO_TAB = {
  p2p_approval_assigned: "p2p",
  approval_assigned: "p2p",
  po_submitted: "fulfilment",
  po_accepted: "fulfilment",
  po_rejected: "fulfilment",
  create_purchase_order: "fulfilment",
  invoice_generated: "fulfilment",
  invoice_accepted: "fulfilment",
  invoice_rejected: "fulfilment",
  eway_generated: "fulfilment",
  create_shipping_manifest: "fulfilment",
  shipping_manifest_submitted: "fulfilment",
  create_grn: "fulfilment",
  grn_created: "fulfilment",
  complete_payment: "fulfilment",
  listing_approval_pending: "auctions",
  listing_approval_rejected: "auctions",
  auction_active: "auctions",
  new_bid_received: "auctions",
  bid_outbid: "auctions",
  auction_bidding_closed: "auctions",
};

const SCOPED_MODULES = new Set(Object.keys(MODULE_TO_TAB));

export function resolveSellerTabForNotification(notification) {
  if (!notification) return null;
  const moduleName = String(notification.module_name || "").toLowerCase();
  if (!SCOPED_MODULES.has(moduleName)) return null;
  const type = String(notification.notification_type || "").toLowerCase();
  return TYPE_TO_TAB[type] || MODULE_TO_TAB[moduleName] || null;
}

export function notificationBelongsToSellerTab(notification, tabKey) {
  if (!notification || !tabKey || tabKey === "overview") {
    return SCOPED_MODULES.has(String(notification?.module_name || "").toLowerCase());
  }
  return resolveSellerTabForNotification(notification) === tabKey;
}

export function buildSellerTabNotificationsPath(tabKey) {
  return buildDashboardTabNotificationsPath({ dashboard: "seller", tabKey });
}
